import { connect } from 'react-redux';
import find from 'lodash/fp/find';
import WindowFlagNotes from './WindowFlagNotes';

const mapDispatchToProps = undefined;

const mapStateToProps = ({
  estimateBuilder:
  {
    entities: { items },
  },
}, ownProps) => {
  const {
    attributes: itemAttributes,
  } = items.byId[ownProps.itemId];

  let flagNotes = [];
  if (find({ name: 'flagNotes' })(itemAttributes)) {
    const flagNotesArray = find({ name: 'flagNotes' })(itemAttributes).value || '[]';
    flagNotes = JSON.parse(flagNotesArray);
  }
  return {
    flagNotes,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WindowFlagNotes);
